
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AsignarActividadParams, InboxProps } from '../../interfaces/comun/InboxInterface';

export const MostrarInbox = () => {

    return new Promise<InboxProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Inbox', null, token)
            .then( ({ data } : { data : InboxProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const AsignarActividad = ( params : AsignarActividadParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Inbox/AsignarActividad', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}